import { escapeHtml } from './attributeParsing.js';
import { pdfLabelFor, renderLabeledValuePdfHtml } from './pdf.js';
/** Strip formatting, keeping only digits and a leading '+'. */
export const normalizePhoneValue = (raw) => {
    const trimmed = raw.trim();
    const digits = trimmed.replace(/\D/g, '');
    return trimmed.startsWith('+') ? `+${digits}` : digits;
};
/**
 * Loose validation: 7 to 15 digits after normalization (E.164 bounds), no
 * country-aware rules. Guests enter numbers in their local format; strict
 * E.164 would reject valid entries like "(555) 123-4567".
 */
export const isValidPhone = (raw) => {
    const digits = normalizePhoneValue(raw).replace(/^\+/, '');
    return /^\d{7,15}$/.test(digits);
};
const valueAsString = (value) => (typeof value === 'string' ? value.trim() : '');
export const phoneInputDescriptor = {
    type: 'phone-input',
    // Check-in is deliberately excluded: its editor already ships a legacy
    // Phone Input block (data-form-field="phone"), and a registry twin with the
    // same label would give hosts two indistinguishable blocks persisting
    // through different pipelines (same reasoning as email-input).
    surfaces: ['rental-agreement'],
    blockLabel: 'Phone Input',
    defaultLabel: 'Enter your phone number',
    requiredDefault: true,
    extraAttrs: [],
    valueChannel: 'progress',
    editorPlaceholderHtml: (label) => `<div style="display:flex;align-items:center;gap:10px;pointer-events:none;">
      <span style="font-size:20px;">&#128222;</span>
      <div>
        <div style="font-weight:600;font-size:14px;color:#334155;">${escapeHtml(label)}</div>
        <div style="font-size:12px;color:#94a3b8;">Guest enters their phone number</div>
      </div>
    </div>`,
    validate: (_field, value) => {
        const str = valueAsString(value);
        if (!str)
            return null;
        return isValidPhone(str) ? null : 'Please enter a valid phone number';
    },
    isComplete: (field, value) => {
        const str = valueAsString(value);
        if (!str)
            return !field.required;
        return isValidPhone(str);
    },
    renderPdfHtml: (field, value) => renderLabeledValuePdfHtml(pdfLabelFor(field), escapeHtml(valueAsString(value))),
};
